import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandCapitalSection from './components/BrandCapitalSection';
import MetodoBCISection from './components/MetodoBCISection';
import ServiziSection from './components/ServiziSection';
import TargetSection from './components/TargetSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Brand Capital - Stima e Valorizzazione Brand',
    description: 'Brand Capital è il sistema di governance che rende il valore del brand misurabile, documentabile e coerente nel tempo. Consulenza specializzata per aziende, commercialisti e investitori in tutta Italia.',
    keywords: 'valutazione brand, perizia marchio, brand valuation, asset intangibili, metodologia certificata',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'Brand Capital',
      description: 'Brand Capital è il sistema di governance che rende il valore del brand misurabile, documentabile e coerente nel tempo',
      url: siteUrl,
      logo: `${siteUrl}/logo.png`,
      areaServed: 'IT',
      serviceType: 'Brand Valuation',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'IT'
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <BrandCapitalSection />
      <MetodoBCISection />
      <ServiziSection />
      <TargetSection />
      <CTASection />
      <Footer />
    </div>
  );
}
